import React from 'react';
import {Button, Space, Typography} from 'antd';
import {useTranslation} from 'react-i18next';

export default function TagDeletionStatus({tag, onRetry}) {
    const {t} = useTranslation();
    return <Space direction="vertical" size={0}>
        <Typography.Text type={tag.deletion.state === 'failed' ? 'danger' : 'secondary'}>
            {tag.deletion.state === 'failed'
                ? t('tag-deletion-interrupted', 'Deletion interrupted; retry scheduled')
                : t('tag-deletion-in-progress', 'Deletion in progress…')}
        </Typography.Text>
        {tag.deletion.state === 'failed' && <Button size="small" onClick={() => onRetry(tag.id)}>
            {t('retry', 'Retry')}
        </Button>}
    </Space>;
}
